import { Component, computed, inject, input, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UIIconComponent } from '@design-system';
import { BottomSheetComponent } from '../../../../components/bottom-sheet/bottom-sheet.component';
import { ExternalUrls } from '../../../../constants/external-urls.constant';

@Component({
	selector: 'app-symbol-detail-more-bottom-sheet',
	imports: [BottomSheetComponent, UIIconComponent],
	templateUrl: './symbol-detail-more-bottom-sheet.component.html',
	host: {
		'data-cy': 'symbol-detail-more-bottom-sheet'
	}
})
export class SymbolDetailMoreBottomSheetComponent {
	private readonly router = inject(Router);
	private readonly sheet = viewChild<BottomSheetComponent>('sheet');

	readonly symbolIsin = input.required<string>();

	readonly imeDetailPageUrl = input<string>();

	readonly imeWarehouseUrl = ExternalUrls.IMEWarehouse;

	readonly easyChartUrl = computed(() =>
		this.router.serializeUrl(this.router.createUrlTree(['/easy-chart', this.symbolIsin()]))
	);

	open(): Promise<void> {
		return this.sheet()?.open() ?? Promise.resolve();
	}

	close(): Promise<void> {
		return this.sheet()?.close() ?? Promise.resolve();
	}

	/**
	 * The sheet goes down before the chart opens. It keeps a history entry of its own for the
	 * back button, and leaving with it still up would strand that entry — back from the chart
	 * would land on it instead of on the board.
	 */
	async onEasyChartClick(event: MouseEvent): Promise<void> {
		event.preventDefault();
		await this.close();
		await this.router.navigateByUrl(this.easyChartUrl());
	}
}
